import React, { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { isEmpty } from 'check-tool';

import { getLanguage } from 'common/i18n';

import MenuTop from 'components/MenuTop';
import MenuLeft from 'components/MenuLeft';
import UsetInfo from 'pages/UsersPage/UsetInfo';
import { AuthContext } from 'AuthProvider';

import { getUserItem } from 'backend/User';

const UserPage = (props) => {
  const [user, setUser] = useState(null);

  const lang = getLanguage();
  const { currentUser } = useContext(AuthContext);
  const { id } = props.match.params;
  
  useEffect(() => {
    if (isEmpty(user)) {
      getUserItem(id)
        .then((result) => {
          setUser(result);
        })
        .catch((error) => {
          console.log('error', error);
          setUser([]);
        });
    }
  });

  if (isEmpty(currentUser)) {
    return <Redirect to="/signin" />;
  }

  return (
    <div>
      <MenuTop lang={lang} user={currentUser} />
      <div className="main-container ace-save-state" id="main-container">
        <MenuLeft lang={lang} user={currentUser} currentPage="users" />
        <div className="main-content">
          <div className="main-content-inner">
            <div className="breadcrumbs ace-save-state" id="breadcrumbs">
              <ul className="breadcrumb">
                <li>
                  <i className="ace-icon fa fa-home home-icon"></i>
                  <a href="/">Главная</a>
                </li>
                <li>
                  <i className="ace-icon fa fa-users users-icon"></i>
                  &nbsp;
                  <a href="/users">Пользователи</a>
                </li>
                <li className="active">{user ? user.displayName : null}</li>
              </ul>
            </div>
            <div className="page-content">
              <div className="row">
						  	<div className="col-xs-12">
                <div className="tabbable">
											<ul className="nav nav-tabs" id="myTab">
												<li className="active">
													<a data-toggle="tab" href="#user" aria-expanded="true">
														<i className="green ace-icon fa fa-user bigger-120"></i>
														&nbsp; Общая информация
													</a>
												</li>

												<li className="">
													<a data-toggle="tab" href="#messages" aria-expanded="false">
                            <i className="blue ace-icon fa fa-envelope bigger-120"></i>
														&nbsp; Сообщения
													</a>
												</li>

                        <li className="">
													<a data-toggle="tab" href="#rating" aria-expanded="false">
                            <i className="blue ace-icon fa fa-bars bigger-120"></i>
														&nbsp; Рейтинг
													</a>
												</li>

												<li className="dropdown">
													<a data-toggle="dropdown" className="dropdown-toggle" href="#" aria-expanded="false">
                            <i className="red ace-icon fa fa-question bigger-120"></i>
														Вопросы &nbsp;
														<i className="ace-icon fa fa-caret-down bigger-110 width-auto"></i>
													</a>

													<ul className="dropdown-menu dropdown-info">
														<li>
															<a data-toggle="tab" href="#dropdown1">@fat</a>
														</li>

														<li>
															<a data-toggle="tab" href="#dropdown2">@mdo</a>
														</li>
													</ul>
												</li>
											</ul>

											<div className="tab-content">
												<div id="user" className="tab-pane fade active in">
													{isEmpty(user) ? null : <UsetInfo user={user}/>}
												</div>

												<div id="messages" className="tab-pane fade">
													<p>Раздел в разработке</p>
												</div>

                        <div id="rating" className="tab-pane fade">
													<p>Раздел в разработке</p>
												</div>

												<div id="dropdown1" className="tab-pane fade">
													<p>Etsy mixtape wayfarers, ethical wes anderson tofu before they sold out mcsweeney's organic lomo retro fanny pack lo-fi farm-to-table readymade.</p>
												</div>

												<div id="dropdown2" className="tab-pane fade">
													<p>Trust fund seitan letterpress, keytar raw denim keffiyeh etsy art party before they sold out master cleanse gluten-free squid scenester freegan cosby sweater. Fanny pack portland seitan DIY, art party locavore wolf cliche high life echo park Austin.</p>
												</div>
											</div>
										</div>
								</div>
						  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserPage;
